/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BookListState from './states/BookListState';

export default {
	'orell-bookshelf/states/BookListState': BookListState,
};
